(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/leave-team-popover-item.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/leave-team-popover-item.js');
'use strict';

const {
  showLeaveTeamError,
  showLeaveTeamQuestionDialog,
  showLeaveTeamSuccess
} = svs.arena.pages.teams.dialogs;
const {
  MemberPopoverItem
} = svs.arena.pages.teams.components;
const {
  removeTeam
} = svs.arena.store.teams.actions;
const {
  deleteMemberAsync
} = svs.arena.service.teamsService;
const LeaveTeamPopoverItem = _ref => {
  let {
    teamId,
    teamName,
    memberBalance
  } = _ref;
  const dispatch = ReactRedux.useDispatch();
  const customerId = ReactRedux.useSelector(state => state.teams.customerId);
  const handleClick = async () => {
    if (!customerId) {
      showLeaveTeamError();
      svs.arena.logger.info('LeaveTeamPopoverItem, CustomerId missing couldnt leave team');
      return;
    }
    if (await showLeaveTeamQuestionDialog("".concat(teamName), memberBalance)) {
      const {
        error
      } = await deleteMemberAsync(teamId, customerId);
      if (error) {
        showLeaveTeamError();
        svs.arena.logger.info('LeaveTeamPopoverItem, Failed to leave team', error);
        return;
      }
      const track = {
        category: 'spela-tillsammans',
        action: 'leave_team',
        opt_label: 'leave'
      };
      svs.components.analytics.trackEvent(track);
      showLeaveTeamSuccess(teamName, memberBalance);
      dispatch(removeTeam(teamId));
    } else {
      const track = {
        category: 'spela-tillsammans',
        action: 'leave_team',
        opt_label: 'cancel'
      };
      svs.components.analytics.trackEvent(track);
    }
  };
  return React.createElement(MemberPopoverItem, {
    onClick: handleClick
  }, "L\xE4mna laget");
};
svs.arena.pages.teams.components.LeaveTeamPopoverItem = LeaveTeamPopoverItem;

 })(window);